import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/es/recursos")({
  component: () => <Outlet />,
});
